import { render } from "./GeneralSegment.vue?vue&type=template&id=6a749c97&scoped=true"
import script from "./GeneralSegment.vue?vue&type=script&lang=ts"
export * from "./GeneralSegment.vue?vue&type=script&lang=ts"

import "./GeneralSegment.vue?vue&type=style&index=0&id=6a749c97&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a749c97"

export default script